import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Bars from 'vuebars';
import VueCookies from 'vue-cookies';
import VueMarkdown from 'vue-markdown';
import App from './App.vue';
import { dom, library } from '../node_modules/@fortawesome/fontawesome-svg-core';
import { faAngleDown } from '../node_modules/@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '../node_modules/@fortawesome/vue-fontawesome';

library.add(faAngleDown);
Vue.component('font-awesome-icon', FontAwesomeIcon);
dom.watch();

Vue.use(VueAxios, axios);
Vue.use(Bars);
Vue.use(VueMarkdown);
Vue.use(VueCookies);
Vue.use(require('vue-moment'));

Vue.config.productionTip = false;

// window object
window.$cookies.config('1d');

new Vue({
  data() {
    return {
      store: {
        debug: false,
        state: {
          epics: [],
          summaryData: [],
          members: [],
          projects: [],
          authenticated: false,
          token: '',
          filter: '',
        },
        setFilter(val) {
          if (this.debug) console.log('setFilter triggered with', val);
          this.state.filter = val;
        },
        clearFilter() {
          if (this.debug) console.log('clearFilter triggered');
          this.state.filter = '';
        },
        setToken(val) {
          if (this.debug) console.log('setToken triggered with', val);

          // NOTE: Mobile Safari will NOT save cookies. Use only for older browsers
          // which do not support the local storage API.

          // --- Local Storage ---
          // Check browser support
          if (typeof (Storage) !== 'undefined') {
            // Store
            localStorage.setItem('token', val);
          } else {
            // Browser does not support Web Storage...
            // --- Cookie ---
            const user = { token: val };
            this.$cookies.set('user', user);
          }

          this.state.token = val;

          if (this.state.token !== '' && this.state.token.length > 0) {
            this.state.authenticated = true;
          } else {
            this.state.authenticated = false;
          }
        },
        getToken() {
          // NOTE: Mobile Safari will NOT save cookies. Use only for older browsers
          // which do not support the local storage API.

          let token = '';
          // --- Local Storage ---
          // Check browser support
          if (typeof (Storage) !== 'undefined') {
            // Retrieve
            token = localStorage.getItem('token');
          } else {
            // Browser does not support Web Storage...
            // --- Cookie ---
            ({ token } = this.$cookies.get('user'));
          }
          this.state.token = token;
          return token;
        },
        clearToken() {
          if (this.debug) console.log('clearToken triggered');
          this.token = '';
          this.authenticated = false;
          // Clear any local storage / cookie
          if (typeof (Storage) !== 'undefined') {
            // Clear
            localStorage.setItem('token', '');
          }
          window.$cookies.remove('user');
        },
        setEpics(val) {
          if (this.debug) console.log('setEpics triggered with', val);
          this.emptyEpics();
          val.forEach((element) => {
            this.addEpic(element);
          });
        },
        addEpic(val) {
          if (this.debug) console.log('addEpic triggered with', val);
          this.state.epics.push(val);
        },
        emptyEpics() {
          if (this.debug) console.log('emptyEpics triggered');
          while (this.state.epics.length > 0) {
            this.state.epics.pop();
          }
        },
        setSummaryData(val) {
          if (this.debug) console.log('setSummaryData triggered with', val);
          this.emptySummaryData();
          val.forEach((element) => {
            this.addSummaryItem(element);
          });
        },
        addSummaryItem(val) {
          if (this.debug) console.log('addSummaryItem triggered with', val);
          this.state.summaryData.push(val);
        },
        emptySummaryData() {
          if (this.debug) console.log('emptySummaryData triggered');
          while (this.state.summaryData.length > 0) {
            this.state.summaryData.pop();
          }
        },
        setMembers(val) {
          if (this.debug) console.log('setMemberstriggered with', val);
          this.emptyMembers();
          val.forEach((element) => {
            this.addMember(element);
          });
        },
        addMember(val) {
          if (this.debug) console.log('addMember triggered with', val);
          this.state.members.push(val);
        },
        emptyMembers() {
          if (this.debug) console.log('emptyMembers triggered');
          while (this.state.members.length > 0) {
            this.state.members.pop();
          }
        },
      },
    };
  },
  render: h => h(App),
}).$mount('#app');
